import React from "react";

export default ({ className }) => (
  <svg className={className} fill="none" viewBox="0 0 30 30">
    <g>
      <path
        fill="currentColor"
        d="M29.9,14.8c-0.1-0.2-1.5-3.4-8.2-4.4c0-0.1,0-0.1,0-0.2V7.9c0-0.4-0.3-0.7-0.7-0.7h-1.7V3.8c0-2.1-1.6-3.8-3.6-3.8H3.6
		C1.6,0,0,1.7,0,3.8v25.5C0,29.7,0.3,30,0.7,30s0.7-0.3,0.7-0.7V3.8c0-1.3,1-2.3,2.2-2.3h12.2c1.2,0,2.2,1,2.2,2.3v3.4h-1.8
		c-0.4,0-0.7,0.3-0.7,0.7v2.3c0,0,0,0,0,0c-6.3,0.8-8,4.4-8.1,4.6c-0.1,0.2-0.1,0.5,0.1,0.7c0.1,0.2,0.3,0.3,0.6,0.3h0.7v2
		c0,0.3,0.3,0.6,0.6,0.6h18.7c0.3,0,0.6-0.3,0.6-0.6v-2h0.6c0.2,0,0.5-0.1,0.6-0.3C30,15.3,30,15,29.9,14.8z M16.9,8.6h3.5v0.9h-3.5
		V8.6z M17.9,11.5c0.3,0,0.7,0,1,0c5.3,0.2,7.9,1.8,9,2.8H9.5C10.5,13.2,12.9,11.5,17.9,11.5z M27.5,17.2H9.9v-1.4h17.6V17.2z"
      />
      <path
        fill="currentColor"
        d="M10.5,24.3c-0.4,0-0.7,0.3-0.7,0.7v1.6c0,0.4,0.3,0.7,0.7,0.7c0.4,0,0.7-0.3,0.7-0.7V25C11.2,24.6,10.9,24.3,10.5,24.3z"
      />
      <path
        fill="currentColor"
        d="M10.5,20c-0.4,0-0.7,0.3-0.7,0.7v1.6c0,0.4,0.3,0.7,0.7,0.7c0.4,0,0.7-0.3,0.7-0.7v-1.6C11.2,20.3,10.9,20,10.5,20z"
      />
      <path
        fill="currentColor"
        d="M14.7,20c-0.4,0-0.7,0.3-0.7,0.7v1.6c0,0.4,0.3,0.7,0.7,0.7c0.4,0,0.7-0.3,0.7-0.7v-1.6C15.4,20.3,15.1,20,14.7,20z"
      />
      <path
        fill="currentColor"
        d="M14.7,24.3c-0.4,0-0.7,0.3-0.7,0.7v1.6c0,0.4,0.3,0.7,0.7,0.7c0.4,0,0.7-0.3,0.7-0.7V25C15.4,24.6,15.1,24.3,14.7,24.3z"
      />
      <path
        fill="currentColor"
        d="M19,24.3c-0.4,0-0.7,0.3-0.7,0.7v1.6c0,0.4,0.3,0.7,0.7,0.7c0.4,0,0.7-0.3,0.7-0.7V25C19.7,24.6,19.4,24.3,19,24.3z"
      />
      <path
        fill="currentColor"
        d="M19,20c-0.4,0-0.7,0.3-0.7,0.7v1.6c0,0.4,0.3,0.7,0.7,0.7c0.4,0,0.7-0.3,0.7-0.7v-1.6C19.7,20.3,19.4,20,19,20z"
      />
      <path
        fill="currentColor"
        d="M23.2,24.3c-0.4,0-0.7,0.3-0.7,0.7v1.6c0,0.4,0.3,0.7,0.7,0.7c0.4,0,0.7-0.3,0.7-0.7V25C23.9,24.6,23.6,24.3,23.2,24.3z"
      />
      <path
        fill="currentColor"
        d="M23.2,20c-0.4,0-0.7,0.3-0.7,0.7v1.6c0,0.4,0.3,0.7,0.7,0.7c0.4,0,0.7-0.3,0.7-0.7v-1.6C23.9,20.3,23.6,20,23.2,20z"
      />
      <path
        fill="currentColor"
        d="M27.5,24.3c-0.4,0-0.7,0.3-0.7,0.7v1.6c0,0.4,0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7V25C28.2,24.6,27.9,24.3,27.5,24.3z"
      />
      <path
        fill="currentColor"
        d="M27.5,20c-0.4,0-0.7,0.3-0.7,0.7v1.6c0,0.4,0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7v-1.6C28.2,20.3,27.9,20,27.5,20z"
      />
    </g>
  </svg>
);
